// extracted by mini-css-extract-plugin
export default {"collapse":"AgCollapse_collapse__22Bkh","collapsed":"AgCollapse_collapsed__EbBAA","expanded":"AgCollapse_expanded__v04u5","expandedDone":"AgCollapse_expandedDone__NWC9d"};